module.exports = __webpack_public_path__ + "img/ta.27be923d.png";